import React from "react";
import "./TypingEffect.css";

const TypingEffect = ({ text }) => {
  return (
    <div className="text-wrapper">
      <span className="outline-text">{text}</span>
    </div>
  );
};

export default TypingEffect;

/*

<div
        style={{
          fontWeight: "bold",
          padding: "20px",
          whiteSpace: "pre",
        }}
      >
        {words.map((word, idx) => (
          <span
            key={idx}
            style={{
              color: coloredWords[idx] === "white" ? "white" : "#d82ad8de",
              maskImage:
                coloredWords[idx] === "gradient"
                  ? "linear-gradient(90deg, #d82ad8de 0%, #a259f7 100%)"
                  : "none",
              WebkitMaskImage:
                coloredWords[idx] === "gradient"
                  ? "linear-gradient(90deg, #d82ad8de 0%, #a259f7 100%)"
                  : "none",
              transition: "all 0.3s ease-in-out",
              display: "inline-block",
              padding: "0 2px",
              transform:
                coloredWords[idx] === "gradient" ? "scale(1.05)" : "scale(1)",
            }}
          ></span>
        ))}
      </div>*/
